import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'allas-banner-principal-cambio-filtros',
  imports: [CommonModule],
  template: `
    <section
      class="grid grid-cols-12 bg-cover bg-center bg-no-repeat xl:px-4 2xl:px-14 py-2 xl:py-14 min-h-[280px] xl:min-h-[600px] relative content-end xl:content-normal"
      id="banner-principal-cambio-filtros"
    >
      <div
        class="flex col-start-6 xl:col-start-10 col-end-13 flex-col gap-2 xl:gap-8 items-center text-white"
      >
        <ng-container *ngTemplateOutlet="servicioProfesional"></ng-container>
        <ng-container
          *ngTemplateOutlet="encuentraTuTiendaButton"
        ></ng-container>
      </div>
    </section>

    <ng-template #encuentraTuTiendaButton>
      <a
        href="encuentra-tu-tienda"
        class="text-[10px] xl:text-base bg-allasRed text-white px-2 xl:px-5 py-1 rounded-md xl:rounded-lg xl:absolute xl:bottom-8 xl:right-1/2 xl:translate-x-1/2 hover:scale-105 transition-all duration-300 xl:mr-6 flex items-center justify-center w-max m-1"
      >
        ENCUENTRA TU TIENDA
      </a>
    </ng-template>

    <ng-template #servicioProfesional>
      <span
        class="text-[10px] xl:text-[1.5rem] text-center fs-condensed -mb-3 xl:-mb-5"
      >
        SERVICIO PROFESIONAL DE
      </span>
      <span
        class="text-2xl xl:text-[3.5rem] text-center font-bold fs-condensed -mb-4 xl:-mb-0"
      >
        CAMBIO DE
      </span>
      <span
        class="text-3xl xl:text-[4.85rem] text-center font-bold fs-condensed -mb-2 xl:-mb-0"
      >
        FILTROS
      </span>
      <p class="text-[8px] xl:text-base text-center font-light opacity-80">
        Mantén tu vehículo en óptimas condiciones <br />
        con nuestro servicio especializado de <br />
        cambio de filtros. Protege tu motor y <br />
        mejora el rendimiento de tu carro.
      </p>
    </ng-template>
  `,
  styles: [
    `
      #banner-principal-cambio-filtros {
        background-image: url('/images/services/cambio-filtros/banner-principal-cambio-filtros-mobile.webp') !important;
      }
      @media (min-width: 1280px) {
        #banner-principal-cambio-filtros {
          background-image: url('/images/services/cambio-filtros/banner-principal-cambio-filtros.webp') !important;
        }
      }
    `,
  ],
})
export class BannerPrincipalCambioFiltros {}
